import { NonReturnableFamilies } from '../models/family.enum';
import { isCustomMixProduct } from './custom-mix-product.helper';

export const isNonReturnableProduct = (familyID: number, productID?: string): boolean =>
  NonReturnableFamilies.includes(familyID) || isCustomMixProduct(productID);
